import './home-services.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {AddSubscribers} from "../../../redux/actions";
import {connect} from "react-redux";
import {generateFileMediaUrl} from "../../../utils/generateMediaUrl";
import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {getUrlWithLocal} from "../../../utils/getUrlWithLocal";
import CallModel from "../../../components/modal/callModel/CallModel";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {AboutArrIcon} from "../../../assets/images";


function HomeServices(props) {
    const {services,staticTexts} = props
    const [callModelOpen, setCallModelOpen] = useState(false)
    const [activeIndex,setActiveIndex] = useState(false);

    const toggleCallBtn = () => {
        setCallModelOpen(!callModelOpen)
    }
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(getUrlWithLocal('/services'), {
            state: { isHome: true }
        });
    };

    console.log(services?.mobileMedia?.path,'services')
    return <div className="home_services_wrapper">
        <div className={'home_services_title'}>
            {staticTexts?.homepage_services_title || 'Наши услуги и сервисы'}
        </div>

        <div className={'home_services_content'}>
            <Swiper
                effect={'flip'}
                spaceBetween={'16'}
                watchSlidesProgress={true}
                slidesPerView={1.3}
                pagination={false}
                modules={[Autoplay,Navigation, Pagination]}
                navigation={false}
                loop={true}
                allowTouchMove={true}
                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                }}
                onRealIndexChange={(swiper) => {
                    setActiveIndex(swiper.realIndex)
                }}
                breakpoints={{
                    400: {
                        slidesPerView: 1.3,
                    },
                    600: {
                        slidesPerView: 2,
                    },
                    800: {
                        slidesPerView: 3,
                    },
                    1000: {
                        slidesPerView: 3,
                    },
                    1300: {
                        slidesPerView: 4,
                    },
                    1600: {
                        slidesPerView: 4,
                    },
                }}
            >

                {
                    services?.slice(0,4)?.map((service, index) => {
                        return <SwiperSlide key={index} className={'home_services_item'} onClick={() => window.location.href = getUrlWithLocal('/services')}>
                            <img src={window.innerWidth < 1050 && service?.mobileMedia?.path ? generateFileMediaUrl(service?.mobileMedia?.path) : generateFileMediaUrl(service?.mediaMain?.path)}
                                 alt="servic_img"
                                 className={'services_img'}/>
                            <div className={'services_item_title'}>
                                {service?.title}
                            </div>
                            <span className={'services_index'}>{index + 1}</span>
                        </SwiperSlide>
                    })
                }
            </Swiper>
        </div>
        {
            services?.length > 3 ? <div className={'home_services_last'}>
                <img src= {window.innerWidth < 1050 && services[4]?.mobileMedia?.path ? generateFileMediaUrl(services[4]?.mobileMedia?.path) : generateFileMediaUrl(services[4]?.mediaMain?.path)}
                     alt="servic_img"
                     className={'services_last_img'}/>
                <div className={'services_item_info'}>
                    <div className={'services_last_description'}>
                        {services[4]?.subTitle}
                    </div>
                    <div className={'services_last_title'}>
                        {services[4]?.title}
                    </div>
                    <button onClick={handleClick} className="services_reservation">
                        {staticTexts?.homepage_consultation_text || 'Заказать консультацию'}  <AboutArrIcon/>
                    </button>

                </div>
            </div> : ''
        }
        {
            callModelOpen && <CallModel callModelOpen={callModelOpen}
                                        staticTexts={staticTexts}
                                        toggleCallBtn={toggleCallBtn}/>
        }
    </div>
}
const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'requestLoading',
    'services'
]);

const mapDispatchToProps = {
    AddSubscribers
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeServices);